import { readyMessage } from "./messageTypes";
import { createSubscriberAndNotifier, deserializeMessage } from "./utils";
export * from "./messageTypes";
/**
 * Sets up the connection. Will send 'start-of-connection' signal immediately when created.
 * @param allowedOrigin the origin where we will send our 'start-of-connection' signal
 */
export function initialSender(allowedOrigin) {
    let relevantWindow = window;
    if (window.opener) {
        relevantWindow = window.opener;
    }
    else if (window.parent) {
        relevantWindow = window.parent;
    }
    const messageChannel = new MessageChannel();
    const ourPort = messageChannel.port1;
    const theirPort = messageChannel.port2;
    const messageBase = setupEvents();
    messageBase.setPort(ourPort);
    relevantWindow.postMessage(JSON.stringify(readyMessage()), allowedOrigin, [
        theirPort
    ]);
    return messageBase.handlers;
}
/**
 * Sets up the connection for a client that is supposed to wait for a 'start-of-connection' signal.
 * @param allowedOrigin the origin where we expect our 'start-of-connection' signal to be sent from.
 */
export function initialReceiver(allowedOrigin) {
    const messageBase = setupEvents();
    const listener = (e) => {
        if (e.type !== "message")
            return;
        const msg = e;
        if (msg.origin !== allowedOrigin) {
            //console.log("Received message event, but origin did not match");
            return;
        }
        const data = deserializeMessage(msg.data);
        if (!data || data.type !== "ready") {
            //console.log('Message data was not "ready"', data);
            return;
        }
        // Clean up
        window.removeEventListener("message", listener);
        const port = msg.ports[0];
        messageBase.setPort(port);
        messageBase.handlers.ready._notifyOnReceiveMessage(readyMessage());
    };
    window.addEventListener("message", listener);
    return messageBase.handlers;
}
function setupEvents() {
    let port = null;
    const subscriberAndNotifier = createSubscriberAndNotifier(s => {
        if (port) {
            port.postMessage(s);
        }
        else {
            console.warn("Channel not set up!");
        }
    });
    const handlers = {
        ready: subscriberAndNotifier("ready"),
        data_payload: subscriberAndNotifier("data_payload"),
        trigger_change: subscriberAndNotifier("trigger_change")
    };
    const onMessage = function (ev) {
        //console.log("received message", ev);
        const data = deserializeMessage(ev.data);
        if (!data) {
            return;
        }
        const handler = handlers[data.type];
        if (handler) {
            handler._notifyOnReceiveMessage(data);
        }
    };
    return {
        handlers,
        setPort: (_port) => {
            port = _port;
            _port.onmessage = onMessage;
        }
    };
}
//# sourceMappingURL=index.js.map